import { render, staticRenderFns } from "./newStudyCenter.vue?vue&type=template&id=202b0e64&scoped=true"
import script from "./newStudyCenter.vue?vue&type=script&lang=js"
export * from "./newStudyCenter.vue?vue&type=script&lang=js"
import style0 from "./newStudyCenter.vue?vue&type=style&index=0&id=202b0e64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202b0e64",
  null
  
)

export default component.exports